import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"

import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://seeklogo.com/images/I/istanbul-teknik-universitesi-itu-logo-B6FC9F665B-seeklogo.com.png'
function ITU() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>Istanbul Technical University (ITU)</HighlightedText></>}
        description="Founded in 1773 as Mühendishane-i Bahrî-i Hümâyûn, ITU is one of Turkey’s oldest and most prestigious technical universities. It is known for its strong focus on engineering, architecture, and technology-driven research."
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
      <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Zeynep Ada Şengün</td>
                <td>Industrial Engineering</td>
                <td>2024</td>
                <td>8159 , 7458 , 8215 </td>
                <td>FRC, FLL, FLL Jr</td>
            </tr>
            <tr>
                <td>Abdullah Battal</td>
                <td>Aeronautical Engineering</td>
                <td>2021</td>
                <td>7285 - 8159</td>
                <td>FRC</td>
            </tr>
            <tr>
                <td>Halil Ömer Çelik</td>
                <td>Industrial Engineering</td>
                <td>2021</td>
                <td>7108, 7285, 8159, 25039</td>
                <td>FRC, FTC</td>
            </tr>
            <tr>
                <td>Baran Marap</td>
                <td>Mathematics Engineering</td>
                <td>2019</td>
                <td>6985 , 7285 , 9020</td>
                <td>FRC</td>
            </tr>
            <tr>
                <td>Rabia Tunç</td>
                <td>Industrial Engineering</td>
                <td>2022</td>
                <td>6985 </td>
                <td>FRC</td>
            </tr>

            <tr>
                <td>Sudem Bulut</td>
                <td>Mathematical Engineering</td>
                <td>2022</td>
                <td>8158  , 9029  </td>
                <td>FRC, FTC</td>
            </tr>
        </tbody>
    </table>
</div>
</TwoColumn>
</Container>

<Footer />
        </ AnimationRevealPage>
  )
}

export default ITU